module.exports = __webpack_public_path__ + "static/media/slide-selected.92a70eba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/WelcomeSlider/slide-selected.svg
// module id = 89
// module chunks = 0